import { STATUS_META } from '../utils';

export function CalendarLegend({ counts = {}, summaryText = '' }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 ">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 text-[11px] sm:text-xs text-[#868686]">
        {Object.entries(STATUS_META).map(([key, meta]) => (
          <div key={key} className="flex items-center gap-1.5">
            <span
              className={`w-2 h-2 rounded-full shrink-0 ${meta.barClass}`}
            />
            <span>
              {meta.label}
              {typeof counts[key] === 'number' ? ` (${counts[key]})` : ''}
            </span>
          </div>
        ))}
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full shrink-0 bg-red-500" />
          <span>Closed / Holiday</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full shrink-0 bg-amber-500" />
          <span>Half day</span>
        </div>
      </div>
      {summaryText && (
        <span className="text-[11px] sm:text-xs text-[#A0A0A0] shrink-0 sm:pt-0.5">
          {summaryText}
        </span>
      )}
    </div>
  );
}
